import Button, { ButtonKind, ButtonScale } from 'bloko/blocks/button';
import Gap from 'bloko/blocks/gap';

import useTrls from 'hooks/translation/useTrls';

import CrmActivityForm from 'components/Admin/CrmActivity/CrmActivityForm';
import Owners from 'components/Admin/CrmActivity/Owners';
import saveCrmActivity from 'components/Admin/CrmActivity/saveCrmActivity';
import TitlePage from 'components/Admin/TitlePage';

import { useDispatch } from 'store/utils';

import 'components/Admin/CrmActivity/CrmActivity.less';

const CrmActivity = () => {
    const dispatch = useDispatch();
    const trl = useTrls();
    return (
        <div className="crm-activity-form">
            <TitlePage>{trl('Admin.CrmActivity.title')}</TitlePage>
            <Gap top>
                <CrmActivityForm />
            </Gap>
            <Gap top>
                <Owners />
            </Gap>
            <Gap top>
                <Button kind={ButtonKind.Success} onClick={() => dispatch(saveCrmActivity())} scale={ButtonScale.Large}>
                    {trl('Admin.CrmActivity.save')}
                </Button>
            </Gap>
        </div>
    );
};

export default CrmActivity;
